// src/components/header/HeaderOne.jsx
import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FiX , FiMenu } from "react-icons/fi"; // Added FiMenu and FiX
import { withTranslate } from 'react-redux-multilingual';

class HeaderOne extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open');
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }

    componentDidMount() {
        // Attach click listeners for submenu toggles after the component mounts
        // This ensures that the elements are available in the DOM
        var elements = document.querySelectorAll('.mainmenu-nav .has-dropdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function(e) {
                    // Prevent default link behavior only if it's for a dropdown
                    if (this.parentElement.classList.contains('has-dropdown')) {
                        e.preventDefault(); 
                    }
                    // Close other open submenus
                    document.querySelectorAll('.mainmenu-nav .submenu.active').forEach(submenu => {
                        if (submenu !== this.parentElement.querySelector('.submenu')) {
                            submenu.classList.remove('active');
                            submenu.parentElement.querySelector('a').classList.remove('open');
                        }
                    });
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
    }

    render(){
        return(
            <header className="header header--transparent color--light header-fixed">
                <div className="header-wrapper">
                    <div className="branding">
                        <div className="logo">
                            <Link to={`${process.env.PUBLIC_URL}/`}>
                                <img src={require('../../assets/images/eidocell/logo.png')} alt="Eidocell" />
                            </Link>
                        </div>
                    </div>
                    <div className="page-navigation">
                        <nav className="mainmenu-nav">
                        <ul className="mainmenu">
                                <li><Link to={`${process.env.PUBLIC_URL}/`}><span>Home</span></Link></li>

                                <li className="has-dropdown">
                                    <a href="#usage-dropdown" role="button" tabIndex="0"><span>Usage</span></a>
                                    <ul className="submenu">
                                        <li><Link to="/usage/startup">Startup</Link></li>
                                        {/* <li><Link to="/usage/tutorials">Tutorials</Link></li> */}
                                    </ul>
                                </li>

                                <li><Link to="/download"><span>Download</span></Link></li>
                                <li><Link to="/about"><span>About</span></Link></li>

                                <li><a href="https://github.com/xuzzu/eidocell" target="_blank" rel="noopener noreferrer"><span>Github</span></a></li>
                            </ul>
                        </nav>
                    </div>
                    <div className="header-right">
                        {/* Mobile Menu Trigger */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default withTranslate(HeaderOne);